export class PrintDocumentReadyEventArgs {
    public url: string;
    public handled: boolean = false;

    constructor(url: string) {
        this.url = url;
    }
}
